import { type AppDispatch } from "../../../Application/globaltypes/redux";
import identityProvidersDataService from "../../services/identityProvidersDataService";
import { req, err, got } from "../slices/claimTypesSlice";

export const fetchClaimTypes = (moboId?: string) => async (dispatch: AppDispatch) => {
  dispatch(req());
  try {
    const data = await identityProvidersDataService.getClaimTypes(moboId);
    dispatch(got(data));
  } catch (e) {
    let errorMessage = (e as Error).message;
    dispatch(err(errorMessage));
  }
};
